import { render, staticRenderFns } from "./Claim.vue?vue&type=template&id=66de8e1e"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports